import { Divider as AntdDivider } from 'antd';
import styled, { css } from 'styled-components';
import {
  CpBody00Placeholder,
  CpBody00Secondary,
  CpBody01Secondary,
} from 'components/atoms/customer-portal/typography';
import { Color } from 'components/colors';

export const SideBarItemIcon = styled.div<{ color?: Color }>`
  min-width: 32px;
  min-height: 32px;
  width: 32px;
  height: 32px;
  margin-right: var(--cp-spacing-03);
  display: flex;
  align-items: center;
  justify-content: center;

  ${(props) =>
    props.color
      ? css`
          svg {
            fill: var(--cp-${props.color}-60);
            path {
              stroke: var(--cp-${props.color}-60);
            }
          }
        `
      : css``};
`;

export const SideBarItemName = styled(CpBody01Secondary)`
  margin-bottom: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SideBarItem = styled.div<{
  active?: boolean;
  noHover?: boolean;
}>`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: start;
  padding: var(--cp-spacing-02) var(--cp-spacing-06);
  ${(props) =>
    props?.noHover
      ? css``
      : css`
          :hover {
            background: var(--cp-background-as-white-opacity-02);
          }
          .cp-very-light-background &:hover {
            background: var(--cp-background-as-black-opacity-02);
          }
        `};
  ${(props) =>
    props.active
      ? css`
          background: var(--cp-background-as-white-opacity);

          .cp-very-light-background & {
            background: var(--cp-background-as-black-opacity);
          }
        `
      : css``};

  @media (max-width: 480px) {
    padding-left: var(--cp-spacing-05);
  }
`;
export const SideBarSectionTitle = styled(CpBody00Secondary)`
  margin-bottom: 0;
  padding: var(--cp-spacing-03);
  padding-left: var(--cp-spacing-06);
`;

export const SideBarSection = styled.div``;
export const SideBarDivider = styled(AntdDivider)`
  margin: var(--cp-spacing-05) 0;
  border-color: var(--cp-border-subtle-auto-adjust);
`;

export const Sidebar = styled.div`
  width: 300px;
  height: 100%;
  background-color: var(--cp-background-as-white-opacity);
  padding: var(--cp-spacing-06) 0;
  display: flex;
  flex-direction: column;
  gap: var(--cp-spacing-06);
  overflow-y: auto;

  @media (min-width: 769px) {
    border-right: 1px solid var(--cp-border-subtle);
  }

  @media (max-width: 480px) {
    border: 1px solid var(--cp-border-subtle);
  }

  @media (max-width: 768px) {
    width: 100%;
    border: 1px solid var(--cp-border-subtle);
    border-radius: var(--border-radius-small);
  }
`;

export const AddInProjectButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 24px;
  width: 24px;
  border-radius: var(--border-radius-small);
  cursor: pointer;
  :hover {
    background: var(--cp-background-as-white-opacity);
  }

  .cp-very-light-background &:hover {
    background: var(--cp-background-as-black-opacity);
  }
`;

export const ProjectNameAndChevronWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  width: calc(100% - 50px);
`;

export const ProjectChevronWrapper = styled.div`
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--border-radius-small);
  cursor: pointer;
`;

export const ProjectName = styled(CpBody00Secondary)`
  /* ellipsis */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
`;
export const ProjectNameWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: var(--cp-spacing-04);
  height: 48px;
  ${AddInProjectButton} {
    visibility: hidden;
  }

  :hover {
    background: var(--cp-background-as-white-opacity);
    ${AddInProjectButton} {
      visibility: visible;
    }
  }

  .cp-very-light-background & {
    :hover {
      background: var(--cp-background-as-black-opacity);
    }
  }
`;

export const ProjectEmptyState = styled(CpBody00Placeholder)`
  padding: var(--cp-spacing-02) var(--cp-spacing-06);
`;

export const ProjectWrapper = styled.div<{ isExpanded: boolean }>`
  border-bottom: 1px solid var(--cp-border-subtle-auto-adjust);
  width: 100%;
  ${({ isExpanded }) =>
    isExpanded
      ? css`
          padding-bottom: var(--spacing-06);
        `
      : ''};
  ${SideBarSectionTitle} {
    color: var(--cp-text-placeholder);
  }
  ${SideBarSection}:not(:last-child) {
    margin-bottom: var(--cp-spacing-06);
    @media (max-width: 768px) {
      margin-bottom: var(--cp-spacing-05);
    }
    @media (max-width: 480px) {
      margin-bottom: var(--cp-spacing-04);
    }
  }
  ${SideBarSectionTitle},
  ${ProjectEmptyState} {
    padding-left: var(--cp-spacing-08);
  }
  ${SideBarItem} {
    padding-left: var(--cp-spacing-07);
  }
`;

export const AccountsSidebar = styled(Sidebar)`
  gap: 0;
`;
